const CART_KEY = "cartData";
const POS_CART_KEY = "posCartData";

function safeParse(value) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return [];
  }
}

export function readCart(key = CART_KEY) {
  if (typeof window === "undefined") {
    return [];
  }

  return safeParse(window.localStorage.getItem(key) || "[]");
}

export function writeCart(items, key = CART_KEY) {
  if (typeof window === "undefined") {
    return [];
  }

  window.localStorage.setItem(key, JSON.stringify(items));
  window.dispatchEvent(new Event("storage"));
  return items;
}

export function clearCart(key = CART_KEY) {
  return writeCart([], key);
}

function normalizeItem(item) {
  const productId = item?.productId || item?._id || item?.id || "";
  const productName = item?.productName || item?.name || item?.title || "";
  const lineId =
    item?.lineId ||
    item?.cartId ||
    `${productId}-${item?.long || ""}-${item?.body || ""}-${item?.color || ""}`;

  const price = Number(item?.price || 0);

  return {
    lineId,
    productId,
    productName,
    name: productName,
    image: item?.image || item?.thumbnail || "",
    price,
    originalPrice: Number(item?.originalPrice ?? price),
    quantity: Number(item?.quantity || 1),
    discount: Number(item?.discount || 0),
    long: item?.long || "",
    body: item?.body || "",
    color: item?.color || "",
    sku: item?.sku || "",
    category: item?.category || "",
    status: item?.status || "",
  };
}

export function addCartItem(item, key = CART_KEY) {
  const cart = readCart(key);
  const normalizedItem = normalizeItem(item);
  const existingIndex = cart.findIndex((cartItem) => cartItem.lineId === normalizedItem.lineId);

  if (existingIndex >= 0) {
    const nextCart = [...cart];
    nextCart[existingIndex] = {
      ...nextCart[existingIndex],
      quantity: Number(nextCart[existingIndex].quantity || 0) + Number(normalizedItem.quantity || 1),
    };
    return writeCart(nextCart, key);
  }

  return writeCart([...cart, normalizedItem], key);
}

export function updateCartItem(lineId, updater, key = CART_KEY) {
  const cart = readCart(key).map((item) => {
    if (item.lineId !== lineId) {
      return item;
    }

    const draft = typeof updater === "function" ? updater(item) : { ...item, ...updater };
    return normalizeItem(draft);
  });

  return writeCart(cart, key);
}

export function removeCartItem(lineId, key = CART_KEY) {
  const cart = readCart(key).filter((item) => item.lineId !== lineId);
  return writeCart(cart, key);
}

export function getCartSummary(items) {
  const cartItems = items || [];
  const subtotal = cartItems.reduce(
    (sum, item) =>
      sum + Number(item.originalPrice ?? item.price ?? 0) * Number(item.quantity || 0),
    0
  );
  const total = cartItems.reduce(
    (sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0),
    0
  );
  const discountTotal = subtotal - total;

  return {
    subtotal,
    discountTotal,
    total,
  };
}

export { CART_KEY, POS_CART_KEY };
